import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";

import "../excalidraw-app/sentry";

import DrawolaApp from "./App";
import { initializeAnalytics } from "./analytics/posthog";

import { initializePersistenceHealth } from "./analytics/persistence";

initializeAnalytics();
initializePersistenceHealth();

window.__DRAWOLA_SHA__ = import.meta.env.VITE_APP_GIT_SHA;
const rootElement = document.getElementById("root")!;
const root = createRoot(rootElement);
registerSW();
root.render(
  <StrictMode>
    <DrawolaApp />
  </StrictMode>,
);
